module.exports = __webpack_public_path__ + "static/media/tranzer_plan.0e4f7f5d.png";